/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ delta: NonNullable<unknown>, count: NonNullable<unknown> }} Profile_Bodyfat_DeltaInputs */

const en_us2_profile_bodyfat_delta = /** @type {(inputs: Profile_Bodyfat_DeltaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.delta} point`);
	return /** @type {LocalizedString} */ (`${i?.delta} points`)
	
};

const pt_br2_profile_bodyfat_delta = /** @type {(inputs: Profile_Bodyfat_DeltaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.delta} ponto`);
	return /** @type {LocalizedString} */ (`${i?.delta} pontos`)
	
};

const es_419_profile_bodyfat_delta = /** @type {(inputs: Profile_Bodyfat_DeltaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.delta} punto`);
	return /** @type {LocalizedString} */ (`${i?.delta} puntos`)
	
};

const pt_pt2_profile_bodyfat_delta = /** @type {(inputs: Profile_Bodyfat_DeltaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.delta} ponto`);
	return /** @type {LocalizedString} */ (`${i?.delta} pontos`)
	
};

const fr_fr2_profile_bodyfat_delta = /** @type {(inputs: Profile_Bodyfat_DeltaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.delta} point`);
	return /** @type {LocalizedString} */ (`${i?.delta} points`)
	
};

const de_de2_profile_bodyfat_delta = /** @type {(inputs: Profile_Bodyfat_DeltaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.delta} Punkt`);
	return /** @type {LocalizedString} */ (`${i?.delta} Punkte`)
	
};

const it_it2_profile_bodyfat_delta = /** @type {(inputs: Profile_Bodyfat_DeltaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.delta} punto`);
	return /** @type {LocalizedString} */ (`${i?.delta} punti`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "{delta} point" |
* | * | "{delta} points" |
*
* @param {Profile_Bodyfat_DeltaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_bodyfat_delta = /** @type {((inputs: Profile_Bodyfat_DeltaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Bodyfat_DeltaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_bodyfat_delta(inputs)
	if (locale === "es-419") return es_419_profile_bodyfat_delta(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_bodyfat_delta(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_bodyfat_delta(inputs)
	if (locale === "de-DE") return de_de2_profile_bodyfat_delta(inputs)
	if (locale === "it-IT") return it_it2_profile_bodyfat_delta(inputs)
	return en_us2_profile_bodyfat_delta(inputs)
});
export { profile_bodyfat_delta as "profile.bodyfat_delta" }